export default __webpack_public_path__ + "static/media/boat-hover.8b167869.png";